import { FC } from "react";
import { pluralize } from "@common/helpers/string";
import { CommandsListProps } from "./lib";
import { TaskBulkOptionsCommandsList } from "./TaskBulkOptionsCommandsList";

export const CloseTemplateTaskBulkStageCommandsList: FC<CommandsListProps> = ({
    options = {},
}) => {
    const {
        selectedCloseTemplateTaskCount = 0,
        closeTemplateTaskBulkStageOptions = [],
    } = options;

    return (
        <TaskBulkOptionsCommandsList
            heading={`Set stage for ${selectedCloseTemplateTaskCount} ${pluralize("task", selectedCloseTemplateTaskCount)}`}
            options={closeTemplateTaskBulkStageOptions}
        />
    );
};
